import React, { Component } from 'react'
import Select from 'components/Form/Select'

class SelectItem extends Component {
	constructor(props) {
		super(props)
		this.state = {
			defaultValues: null,
			disabled: false,
		}
	}

	/**
	 * getPreselect {Function}
	 * @description - if we have option 'widget.preselect.enabled'
	 * in shopProperties, need set option in defaultValue
	 * */
	getPreselect = (options) => {}

	/**
	 * getDefaultOption {Function}
	 * @description - set default item in select
	 * */
	getDefaultOption = () => {
		let initialValues = {}
		if (this.props.options.length > 1) {
			// if (this.props.preselect) {
			//     this.getPreselect(this.props.options)
			// }
			initialValues = { label: this.props.keyItem, value: '' }
		} else {
			initialValues = this.props.options[0]
			this.setState({
				disabled: true,
			})
		}

		this.setState({
			defaultValues: initialValues,
		})
	}

	componentDidMount() {
		this.getDefaultOption()
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.defaultValues?.value !== this.state.defaultValues?.value
		) {
			const { onChangeAction, keyItem, idx } = this.props

			onChangeAction({
				idx,
				value: {
					label: keyItem,
					value: this.state.defaultValues.value,
				},
				lastAdd: keyItem,
			})
		}
	}

	isEmpty = (value) => {
		return !value.value
	}

	render() {
		const {
			item,
			setItemState,
			onChangeAction,
			keyItem,
			options,
			idx,
			selected,
			value,
			isSearchable,
		} = this.props

		const { defaultValues, disabled } = this.state
		return (
			defaultValues && (
				<Select
					className='mb-3'
					isDisabled={disabled || selected}
					isClearable={true}
					defaultValue={defaultValues}
					value={value}
					isEmpty={this.isEmpty(value)}
					isSearchable={isSearchable}
					options={[{ label: keyItem, value: '' }, ...options]}
					onChange={(e) => {
						if (e) {
							if (e.value === '') {
								setItemState(item)
							}
							onChangeAction(
								{
									idx,
									value: { label: keyItem, value: e.value },
									lastAdd: keyItem,
								},
								e,
								keyItem
							)
						} else {
							setItemState(item)
							onChangeAction(
								{
									idx,
									value: { label: keyItem, value: '' },
									lastAdd: keyItem,
								},
								{ label: keyItem, value: '' },
								keyItem
							)
						}
					}}
					onMenuOpen={() => {
						let exchangeListPusher = document.getElementById(
							'exchange-list-item-pusher'
						)
						setTimeout(() => {
							if (window.innerWidth < window.innerHeight) {
								let menu = document
									.querySelector('.react-select__menu')
									.getBoundingClientRect()
								let menuTop = parseFloat(menu.top)
								let menuHeight = parseFloat(menu.height)
								let footer = document
									.getElementById('returnado-widget-footer')
									.getBoundingClientRect()
								let footerTop = parseFloat(footer.top)

								if (menuTop + menuHeight > footerTop) {
									exchangeListPusher.style.height =
										menuTop +
										menuHeight -
										footerTop +
										50 +
										'px'
								}
							}
						}, 0)
					}}
					onMenuClose={() => {
						let exchangeListPusher = document.getElementById(
							'exchange-list-item-pusher'
						)
						setTimeout(() => {
							if (window.innerWidth < window.innerHeight) {
								exchangeListPusher.style.height = '0px'
							}
						}, 0)
					}}
				/>
			)
		)
	}
}

export default SelectItem
